import React from 'react';
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import polemiaLogo from '@/assets/polemia-logo-hero.png';

interface ConversationHeaderProps {
  onReset: () => void;
}

const ConversationHeader: React.FC<ConversationHeaderProps> = ({ onReset }) => {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-sm border-b border-border animate-fade-in">
      <div className="px-4 py-3 flex items-center justify-between">
        <a href="https://ia.polemia.com" className="inline-block">
          <img
            src={polemiaLogo}
            alt="IA Polemia"
            className="h-8 object-contain"
          />
        </a>
        <Button
          variant="ghost"
          size="sm"
          onClick={onReset}
          className="gap-2 text-muted-foreground sm:hover:text-primary sm:hover:bg-primary/10"
        >
          <Plus className="w-4 h-4" />
          <span className="hidden sm:inline">Nouvelle recherche</span>
        </Button>
      </div>
    </header>
  );
};

export default ConversationHeader;
